import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ExperiencesView from '../views/ExperiencesView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'signin',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/experiences',
    name: 'experiences',
    component: ExperiencesView
  }, 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
